import * as React from 'react';
import SignaturePad from 'signature_pad';

interface Props {
  handleSign: Function;
}

class Signature extends React.Component<Props> {
  canvas: HTMLCanvasElement;
  pad: SignaturePad;

  componentDidMount() {
    this.pad = new SignaturePad(this.canvas, {
      onEnd: () => {
        if (!this.pad.isEmpty()) {
          this.props.handleSign(this.pad.toDataURL());
        }
      },
    });
    this.componentDidResize();
    window.addEventListener('resize', this.componentDidResize);
  }

  componentDidResize() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvas.width = this.canvas.offsetWidth * ratio;
    this.canvas.height = this.canvas.offsetHeight * ratio;
    this.pad.clear();
  }

  render() {
    return (
      <div className="signature has-text-centered">
        <canvas ref={(element) => (this.canvas = element)} />
      </div>
    );
  }
}

export default Signature;
